import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "custom-form-container" }
const _hoisted_2 = { class: "price-info" }
const _hoisted_3 = { class: "price-label" }
const _hoisted_4 = { class: "price-num" }
const _hoisted_5 = { class: "price-label" }
const _hoisted_6 = { class: "price-num" }
const _hoisted_7 = { class: "price-label" }
const _hoisted_8 = { class: "price-num" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createTextVNode("优惠总额："),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.estimateAmount??0), 1),
        _createTextVNode("元")
      ]),
      _createElementVNode("span", _hoisted_5, [
        _createTextVNode("结算总额："),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.promotionAmount??0), 1),
        _createTextVNode("元")
      ]),
      _createElementVNode("span", _hoisted_7, [
        _createTextVNode("合计："),
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.totalAmount??0), 1),
        _createTextVNode("元")
      ])
    ])
  ]))
}